import React from 'react'
import { shallow } from 'enzyme'

import EtranResults  from '../EtranResults'

describe('EtranResults', () => {
  let wrapper, props, instance
  beforeEach(() => {
    props = {
      api_response_status: "",
      appNumber:"5014096",
      document: {
        adminOnly: true,
        files: {}
      },
      entityId: 17411,
      etranInfo: {
        "plp_authorization_date": "",
      },
      etran_process: "manual",
      loanId:15262,
      setSubmitButtonDisabled: jest.fn(),
      validInput: jest.fn(),
      documentBucketOptions: {
        updatedStageBasedDocumentsExperienceUi: false
      }
    }
    wrapper = shallow(<EtranResults {...props} />)
    instance = wrapper.instance()
  })

  describe('#isSuccessResponse', () => {
    describe('when api_response_status is not success', () => {
      it('should return false ', () => {
          expect(wrapper.instance().isSuccessResponse).toBeFalsy()
      })
    })
    describe('when api_response_status is success', () => {
      it('should return true ', () => {
        props.api_response_status= "success";
        wrapper = shallow(<EtranResults {...props} />)
        instance = wrapper.instance()
        expect(wrapper.instance().isSuccessResponse).toBeTruthy()
      })
    })
  })

  describe('#isManualProcess', () => {
    describe('when etran_process is not manual', () => {
      it('should return false ', () => {
          props.etran_process= "";
          wrapper = shallow(<EtranResults {...props} />)
          instance = wrapper.instance()
          expect(wrapper.instance().isManualProcess).toBeFalsy()
      })
    })
    describe('when etran_process is success', () => {
      it('should return true ', () => {
        props.etran_process= "manual";
        wrapper = shallow(<EtranResults {...props} />)
        instance = wrapper.instance()
        expect(wrapper.instance().isManualProcess).toBeTruthy()
      })
    })
  })

  describe('#showBanner', () => {
    describe('when api_response_status is not success', () => {
      it('should return false ', () => {
          props.api_response_status= "";
          wrapper = shallow(<EtranResults {...props} />)
          instance = wrapper.instance()
          expect(wrapper.instance().showBanner).toBeFalsy()
      })
    })
    describe('when api_response_status is success', () => {
      it('should return true ', () => {
        props.api_response_status= "success";
        wrapper = shallow(<EtranResults {...props} />)
        instance = wrapper.instance()
        expect(wrapper.instance().showBanner).toBeTruthy()
      })
    })
  })

  describe('#renderFormInput', ()=>{
    it('should return 12 if name is plp_authorization_number', ()=>{
      const obj = wrapper.instance().renderFormInput('plp_authorization_number', 'Ex. 4378905002 (do not include -)', false, 123456789);

      expect(obj.props.maxLength).toEqual(12)
    })

    it('should return undefined if name is not plp_authorization_number', ()=>{
      wrapper = shallow(<EtranResults {...props} />)
      const obj = wrapper.instance().renderFormInput('etran_score', 'Ex. 4378905002 (do not include -)', false, 123456789);

      expect(obj.props.maxLength).toEqual(undefined)
    })
  })
})
